import { makeAutoObservable } from 'mobx';
import { IUserStore } from './IUserStore';
import { User } from 'domains/user';
import { IUserService } from 'application/services/user';

export class UserStore implements IUserStore {
  private _user: User | undefined = undefined;
  private _authed: boolean | undefined = undefined;
  private _isAuthenticating: boolean = true;
  private _isAdmin: boolean = false;

  constructor(private readonly service: IUserService) {
    makeAutoObservable(this);
  }

  set isAdmin(value: boolean) {
    this._isAdmin = value;
  }

  get isAdmin(): boolean {
    return this._isAdmin;
  }
  set authed(value: boolean | undefined) {
    this._authed = value;
  }

  get authed(): boolean | undefined {
    return this._authed;
  }
  set user(value: User | undefined) {
    this._user = value;
  }

  get user(): User | undefined {
    return this._user;
  }

  set isAuthenticating(value: boolean) {
    this._isAuthenticating = value;
  }

  get isAuthenticating(): boolean {
    return this._isAuthenticating;
  }

  async login(username: string, password: string): Promise<void> {
    await this.service.login({ username, password });
    await this.authenticate();
  }

  async authenticate(): Promise<void> {
    try {
      this.user = await this.service.authenticate();
      this.authed = true;
      this.isAuthenticating = false;
    } catch (error) {
      this.authed = false;
      this.isAuthenticating = false;
    }
  }

  async updateFCMToken(fcmToken: string): Promise<void> {
    await this.service.updateFCMToken(fcmToken);
  }

  async logout(): Promise<void> {
    await this.service.logout();
    this.user = undefined;
    this.authed = undefined;
    this.isAdmin = false;
  }

  async deleteAccount(): Promise<void> {
    await this.service.deleteAccount();
    this.user = undefined;
    this.authed = undefined;
    this.isAdmin = false;
  }
}
